import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import Layout from "@/components/layout/Layout";
import CookieConsent from "@/components/CookieConsent";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Servicos from "@/pages/Servicos";
import Orcamento from "@/pages/Orcamento";
import VisitaTecnica from "@/pages/VisitaTecnica";
import Contato from "@/pages/Contato";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import "@/App.css";

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <GoogleAnalytics />
        <CookieConsent />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/orcamento" element={<Orcamento />} />
            <Route path="/visita-tecnica" element={<VisitaTecnica />} />
            <Route path="/contato" element={<Contato />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
